import React, { useCallback, useEffect } from 'react'

import { useProductMessages } from '../hooks/useProductMessages'

import { BUTTON_PRESS, VIEW, trackEvent } from '@/utils/analytics'

import { pmtToAlertString } from '../utils/utils'
import { StaticBanner } from './StaticBanner'

const ANALYTIC_NAME = 'Product Message Banner' as const

/**
 * ProductMessageBanner component displays active product messages to users.
 *
 * @returns A banner component or null if no message should be displayed
 */
export const ProductMessageBanner: React.FC = () => {
  const { currentMessage, isLoading, error, dismissMessage } =
    useProductMessages()

  // Track when a message is shown to the user
  useEffect(() => {
    if (currentMessage?.id) {
      trackEvent(`${VIEW} ${ANALYTIC_NAME}`, {
        messageId: currentMessage.id,
        message: currentMessage.message,
        type: currentMessage.messageType,
      })
    }
  }, [currentMessage?.id, currentMessage?.message])

  const handleDismiss = useCallback(() => {
    if (currentMessage?.id) {
      dismissMessage(currentMessage.id)

      trackEvent(`${BUTTON_PRESS} ${ANALYTIC_NAME} - Dismiss`, {
        messageId: currentMessage.id,
        message: currentMessage.message,
        type: currentMessage.messageType,
      })
    }
  }, [currentMessage, dismissMessage])

  if (
    isLoading ||
    error ||
    !currentMessage?.message?.trim() ||
    !currentMessage?.id
  ) {
    return null
  }

  return (
    <StaticBanner
      message={currentMessage.message}
      onDismiss={handleDismiss}
      status={pmtToAlertString(currentMessage.messageType)}
    />
  )
}
